import React, { Component } from 'react'
import { DeletePopup } from '../../../../Components/Common Components/CommonComponents'
import { withTranslation } from 'react-i18next';
import { DataGrid } from '@mui/x-data-grid';
import { Box, Button, Stack, Tooltip, Typography, TextField } from '@mui/material';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import ShowComponents from '../Common/ShowComponent';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import { CommonDeleteButton } from '../../../../Components/Common Components/CommonComponents';

class DocPastHistoryLeft extends Component {
    constructor(props) {
        super(props)
        this.state = {
            pastHistoryData: [],
            comments: "",
            isDeleteCliked: false,
            SelectedList: {},
            PatientData: this.props?.PatientData,
            isEdit: false,
        }
    }

    componentDidUpdate(prevprops) {
        if (prevprops.GetAPiCall !== this.props.GetAPiCall && this.props.GetAPiCall) { this.getPastHistoryData() }
        if (prevprops.SelectedComponent !== this.props.SelectedComponent) {
            this.props.EditPastHistoryData({ comments:  this.state.comments || "" })
            if (this.props.SelectedComponent !== "past_history" && this.state.isEdit) {
                this.setState({ isEdit: false });
            }
        }
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message
        })
    }

    getPastHistoryData = () => {
        try {
            RestAPIService.getAll(Serviceurls.DOC_PAST_HISTORY_GET + `?appointment_id=${this.props.PatientData.appointment_id}`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        const Data = response?.data?.data?.past_history?.map((item, index) => ({
                            ...item,
                            sno: index + 1,
                            displayDuration: (item.duration && item.duration_mode) ? `${item.duration} ${item.duration_mode}` : "-"
                        }))
                        this.setState({
                            pastHistoryData: Data || [],
                            comments: response?.data?.data?.comments || "",
                            isEdit: false,
                        }, () => { this.props.EditPastHistoryData({ comments:  response?.data?.data?.comments || "" })})
                    }
                }).catch((error) => {
                    this.errorMessage(error?.response?.data?.message || error?.message)
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }


    onEditHandler(data) {
        this.setState({
            isEdit: true
        }, () => {
            this.props.EditPastHistoryData({ ...data, comments: this.state.comments })
        })
    }

    onDeleteHandler(data) {
        try {
            this.setState({
                isDeleteCliked: true,
                SelectedList: data,
            })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    popupClose() {
        this.setState({ isDeleteCliked: false, SelectedList: {}, removeData: false })
    }

    DeletePastData = () => {
        try {
            let data = {}
            this.setState({ removeData: true })
            RestAPIService.delete(Serviceurls.DOC_PAST_HISTORY_GET + `?id=${this.state.SelectedList?.id}`, data)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.popupClose()
                        this.successMessage(response?.data?.message)
                        this.getPastHistoryData()
                    }
                }).catch((error) => {
                    this.setState({ removeData: false })
                    this.errorMessage(error?.response?.data?.message || error?.message)
                })
        } catch (error) {
            this.setState({ removeData: false })
            this.errorMessage(error.message)
        }
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    deleteComments = () => {
        const { appointment_id, patient_id } = this.props.PatientData;
        try {
            const data = {
                "appointment_id": appointment_id,
                "patient_id": patient_id,
                "comments": "",
                "past_history": []
            }
            RestAPIService.create(data, Serviceurls.DOC_PAST_HISTORY_GET)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.successMessage(response?.data?.message)
                        this.getPastHistoryData()
                    }
                }).catch((error) => {
                    this.errorMessage(error?.response?.data?.message || error?.message)
                })

        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    render() {
        const { t } = this.props
        const columns = [
            {
                field: "past_history", flex: 0.4, headerName: t("History"),
                renderCell: ({ row }) => {
                    return (<Box component={'div'} emed_tid={`doc_past_history_left_history_cell_${row.sno}`}>
                        {row?.past_history?.length > 40 ?
                            <Tooltip placement='top' title={row?.past_history} arrow emed_tid={`doc_past_history_left_history_tooltip_${row.sno}`}>
                                <div emed_tid={`doc_past_history_left_history_text_${row.sno}`}>{row?.past_history.slice(0, 40) + "..."}</div></Tooltip> :
                            row?.past_history || "-"}
                    </Box>)
                }
            },
            {
                field: "displayDuration", flex: 0.4, headerName: t("Duration"), headerAlign: "center", align: 'center',
                renderCell: ({ row }) => {
                    return (<Box emed_tid={`doc_past_history_left_duration_cell_${row.sno}`}>
                        {
                            row?.displayDuration?.length > 40 ?
                                <Tooltip placement='top' title={row?.displayDuration} emed_tid={`doc_past_history_left_duration_tooltip_${row.sno}`}>
                                    <Typography fontSize={'0.8vw'} fontWeight={600} mr={'0.5vw'} sx={{textTransform: "capitalize"}} emed_tid={`doc_past_history_left_duration_text_${row.sno}`}>{row?.displayDuration?.slice(0, 40) + '...'}</Typography>
                                </Tooltip> :
                                <Typography fontSize={'0.8vw'} fontWeight={600} mr={'0.5vw'} sx={{textTransform: "capitalize"}} emed_tid={`doc_past_history_left_duration_text_${row.sno}`}>{row?.displayDuration || '-'}</Typography>
                        }
                    </Box>)
                }
            },
            {
                field: "action", flex: 0.2, headerName: t("Action"), headerAlign: "center", align: "center",
                renderCell: ({ row }) => {
                    const is_locked = this.state.isLocked || this.props.isLocked;
                    return (<Box display={"flex"} flexDirection={"row"} alignItems={"center"} emed_tid={`doc_past_history_left_action_cell_${row.sno}`}>
                        <Button className='Common_Btn_Min_Width'
                            emed_tid={`doc_past_history_left_edit_btn_${row.sno}`}
                            disabled={is_locked}
                            onClick={() => { this.onEditHandler(row) }}
                        >
                            <Tooltip placement='top' title={'Edit'} emed_tid={`doc_past_history_left_edit_tooltip_${row.sno}`}>
                                <Box component={'img'} src={is_locked ? ImagePaths.DisabledEdit.default : ImagePaths.UserEditOn.default} height={'1.2vw'} width={'1.2vw'} emed_tid={`doc_past_history_left_edit_icon_${row.sno}`} />
                            </Tooltip>
                        </Button>
                        <Button className='Common_Btn_Min_Width' disabled={is_locked || this.state.isEdit}
                            emed_tid={`doc_past_history_left_delete_btn_${row.sno}`}
                            onClick={() => this.onDeleteHandler(row)}
                        >
                            <Box component={'img'} src={(is_locked || this.state.isEdit) ? ImagePaths.DisabledDelete.default : ImagePaths.DeleteOutline.default} height={'1.2vw'} width={'1.2vw'} emed_tid={`doc_past_history_left_delete_icon_${row.sno}`} />
                        </Button>
                    </Box>)
                }
            }
        ]
        return (
            <ShowComponents onIntersection={this.getPastHistoryData.bind(this)}>
                <Box height={'20vh'} overflow={'auto'} emed_tid="doc_past_history_left_container">
                    <DataGrid
                        emed_tid="doc_past_history_left_datagrid"
                        density='compact'
                        rows={this.state.pastHistoryData}
                        columns={columns}
                        getRowId={(row) => row['sno']}
                        headerHeight={40}
                        hideFooter={true}
                        components={{
                            NoRowsOverlay: () => (
                                <Stack className='eMed_DocNotes_no_records_text' height={'15vh'} emed_tid="doc_past_history_left_no_rows">
                                    {t("NoRecordsFound")}
                                </Stack>
                            )
                        }}
                        disableSelectionOnClick
                    />
                </Box>
                <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'} emed_tid="doc_past_history_left_description_box">
                    <TextField
                        emed_tid="doc_past_history_left_description_textfield"
                        size='small'
                        sx={{ width: '54vw', margin: '1vw' }}
                        multiline={true}
                        label={"Description"}
                        value={this.state.comments}
                        InputProps={{ readOnly: true, emed_tid: "doc_past_history_left_description_input" }}
                        maxRows={5}
                    />
                    <CommonDeleteButton emed_tid='past_history_description_delete_button' size={"1.5vw"} disable={this.props?.isLocked || !this.state.comments} onClick={this.deleteComments.bind(this)} />
                </Box>
                {this.state.isErrorMsg && <ToastMsg
                    emed_tid="doc_past_history_left_error_toast"
                    severity={'error'}
                    msg={this.state.isErrorMsgText}
                    msgPop={this.msgClose.bind(this)}
                />}
                {this.state.successMsg && <ToastMsg
                    emed_tid="doc_past_history_left_success_toast"
                    severity={'success'}
                    msg={this.state.successMsgText}
                    msgPop={this.msgClose.bind(this)}
                />}
                {this.state.isDeleteCliked && <DeletePopup
                    emed_tid="doc_past_history_left_delete_popup"
                    DeletTitle={`${t("deleteMsg")} ${this.props.custom_name ? this.props.custom_name : "Past History"} ${this.state.SelectedList ? this.state.SelectedList?.past_history : "-"} ?`}
                    deleteAlertPopupClose={this.popupClose.bind(this)}
                    removeData={this.DeletePastData.bind(this)}
                />}
            </ShowComponents>
        )
    }
}

export default withTranslation()(DocPastHistoryLeft)